import { useState } from "react";
import Button from "../layout/Button"
import RegisterModal from "./RegisterModal"


export default function BecomeAMember() {

  const [showRegisterModal, setShowRegisterModal] = useState<boolean>(false);
  return (
    <>

      {/* Register modal */}
      <RegisterModal show={showRegisterModal} setShow={setShowRegisterModal} />

      <div className="bg-yellow py-12 sm:py-20">
        <div className="mx-auto max-w-7xl px-6 lg:px-8 flex flex-row flex-wrap gap-4 sm:flex-nowrap justify-center gap-x-20 relative">
          <h1 className="text-2xl sm:text-4xl lg:text-6xl font-semibold text-dark-grey">Become a member - it's free!</h1>

          {/* Crowdfunding */}
          <Button
            bgColour="dark-grey"
            textColour="white"
            width="fit"
            paddingX="6"
            paddingY="0.5"
            onClick={() => setShowRegisterModal(true)}
          >
            <span className="">Sign up</span>
          </Button>

          {/* Bubbles */}
          <img
            src="/img/graphics/bubbles/bubble-top-orange.svg"
            alt="Bubble"
            className="absolute w-28 md:w-40 xl:w-60 object-cover -top-20 md:-top-32 xl:-top-44 right-20 xl:right-10 z-0"
          />

        </div>
      </div>
    </>
  )
}
